"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var FirstLineTextContainer_1 = require("./FirstLineTextContainer");
var MessageAdListItemIconBar_1 = require("./MessageAdListItemIconBar");
var mobx_react_1 = require("mobx-react");
var owa_messagead_strings_1 = require("owa-strings/owa-messagead-strings");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var ThreeLineViewSenderLine = /** @class */ (function (_super) {
    tslib_1.__extends(ThreeLineViewSenderLine, _super);
    function ThreeLineViewSenderLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThreeLineViewSenderLine.prototype.render = function () {
        var isReadingPanePositionOff = false;
        var adTextClass = classNames(styles.adText, styles.adTextreadingPaneOn);
        // We need to give this div a pre-defined height as FAN ad does not have the sender text at the first loading
        // Without the predefined height, we will see a blank UI re-flow
        var senderDivClass = classNames(this.props.isUnread ? styles.firstRowThreeColumnUnread : styles.firstRowThreeColumn, this.props.senderTexts ? null : styles.messageLineHeightReadingPaneOn);
        return (React.createElement("div", { className: senderDivClass },
            React.createElement("span", { className: classNames(adTextClass, 'fbAdLink') }, owa_messagead_strings_1.default.adTextSubjectLabel),
            React.createElement(FirstLineTextContainer_1.default, { firstLineText: this.props.senderTexts, isUnread: this.props.isUnread, isReadingPanePositionOff: isReadingPanePositionOff }),
            React.createElement(MessageAdListItemIconBar_1.default, { adChoiceUrl: this.props.iconBarUrl, adId: this.props.adId })));
    };
    ThreeLineViewSenderLine = tslib_1.__decorate([
        mobx_react_1.observer
    ], ThreeLineViewSenderLine);
    return ThreeLineViewSenderLine;
}(React.Component));
exports.default = ThreeLineViewSenderLine;
//# sourceMappingURL=ThreeLineViewSenderLine.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/ThreeLineViewSenderLine.js
// module id = 6006
// module chunks = 67